// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UWXZd","list":"styles_list__tzUJ3","active":"styles_active__B86V6","reward":"styles_reward__v1f3T","pressed":"styles_pressed__eVFeU"};